module.exports = __webpack_public_path__ + "media/images/dashboard_icons/gross_sale-02331ffea78d88257838733400d3d46d.svg";